module.exports = __webpack_public_path__ + "static/1322056097-wide.b2d3b421.jpg";